import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts'
import { graficoTicketMedio } from '../../interfaces/graficos'
import { ticketMedio } from '../../services/dashboardFinanceiro'
import LoadingCirculo from '../LoadingCirculo'
import NenhumDadoGrafico from '../NenhumDadoGrafico'
import './ticketmedio.css'

function GraficoTicketMedio () {

    const navigate = useNavigate()

    const [carregando, setCarregando] = useState (true)
    const [grafico, setGrafico] = useState (false)
    const [dados, setDados] = useState<graficoTicketMedio []>([])
    const [valorMaximo, setValorMaximo] = useState(0)
    const [semDados, setSemDados] = useState (false)

    useEffect (() => {

        const ticket = async () => {

            try {
                const resposta = await ticketMedio ()
                setCarregando (false)
                setDados (resposta.data)

                if (resposta.data.length === 0) {
                    return setSemDados(true)
                }
                setGrafico (true)

            } catch (error:any) {

                if (error.status === 401) {
                    return navigate('/');
                }
            }
        }

        ticket ()

    }, [navigate])

    useEffect (() => {

        let valorMaximo = 0

        dados.forEach (valor => {
            if (Number(valor.ticketMedio) > valorMaximo) {
                valorMaximo = Number(valor.ticketMedio)
            }
        })

        return setValorMaximo(Number(valorMaximo.toFixed()))

    }, [dados])


    return (
            <div id = 'graficoTicketMedio'>
                <p id='graficoTicketMedioP'>TICKET MÉDIO POR MÊS</p>
                {carregando && <LoadingCirculo/>}
                {grafico && <ResponsiveContainer>
                    <AreaChart data={dados} margin={{ top: 10, right: 40, left: 0, bottom: 0 }}>
                    <defs>
                        <linearGradient id="clientes_ativos_mes" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#25AE88" stopOpacity={1}/>
                            <stop offset="95%" stopColor="#25AE88" stopOpacity={0.4}/>
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="competência" />
                    <YAxis domain={[0, valorMaximo]} allowDecimals={false}/>
                    <CartesianGrid strokeDasharray="6 6" />
                    <Tooltip />
                    <Area type="monotone" dataKey="ticketMedio" strokeWidth={2} stroke="#25AE88"  activeDot = {{r: 8}} fillOpacity={1} fill="url(#clientes_ativos_mes)" />
                    </AreaChart>
                </ResponsiveContainer>}
                {semDados && <NenhumDadoGrafico texto='Sem Dados para' subtexto='exibir o gráfico'/>}
            </div>
    )
}

export default GraficoTicketMedio